var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dwon"}},[_c('ul',_vm._l((_vm.list),function(item,i){return _c('li',{key:item.id,class:i === _vm.list.length - 1 ? '' : 'list'},[_c('p',{domProps:{"innerHTML":_vm._s(item.title)}})])}),0),_c('Paging',{attrs:{"total":_vm.total,"curPage":_vm.page,"limit":10,"showPage":5},on:{"changePager":_vm.handlePager}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }